<template>
  <div
    class="form-group"
    :class="{ 'has-error': errors.has(validationName), 'form-group-active': active }"
  >
    <label class="control-label" v-if="label">{{ label }}</label>
    <select
      v-if="optgroups"
      ref="select"
      class="form-control"
      :value="value"
      :name="name"
      :readonly="readonly"
      :disabled="disabled"
      :data-vv-as="label"
      @input="$emit('input', $event.target.value)"
      @change="$emit('input', $event.target.value)"
      @blur="changeFocus()"
      @focus="changeFocus()"
    >
      <option v-if="placeholder" value>{{ placeholder }}</option>
      <optgroup v-for="(optgroup, key) in optgroups" :key="key" :label="optgroup.name">
        <option
          v-for="option in optgroup.options"
          :key="option.value"
          :value="option.value"
        >{{ option.text }}</option>
      </optgroup>
    </select>
    <error-message :message="errors.first(validationName)"></error-message>
  </div>
</template>

<script>
export default {
  inject: ["$validator"],
  name: "form-group-select-group",
  props: {
    label: String,
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: String,
    optgroups: Array
  },
  mounted() {
    this.$el.value = this.value;
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    validationName() {
      return this.scope ? `${this.scope}.${this.name}` : this.name;
    }
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormGroupSelectGroup.vue